<h5 mat-dialog-title>Authentication</h5>
<div class="panel">
	<div class="panel-body">
		<div class="error-container">
			<ng-container *ngIf="errorMessage">
				<div class="alert alert-danger" role="alert">
					{{ errorMessage }}
				</div>
			</ng-container>
		</div>
		<form [formGroup]="formGroup" class="needs-validation" novalidate (ngSubmit)="submit()" fxLayout="column"
			fxLayoutGap="10px">
			<div class="form-group">
				<label class="small mb-0">User Name? </label>
				<div class="input-group">
					<!-- <div class="input-group-prepend"> -->
					<span class="input-group-text" id="basic-addon1"><i class="fas fa-user"></i></span>
					<!-- </div> -->
					<input id="userName" class="form-control" formControlName="username" placeholder="User Name"
						[ngClass]="{ 'is-invalid': username.invalid && formSubmitAttempt }" />
				</div>
			</div>
			<div class="form-group mb-0">
				<label class="small mb-0">Password </label>
				<div class="input-group">
					<!-- <div class="input-group-prepend"> -->
					<span class="input-group-text" id="basic-addon1"><i class="fas fa-key"></i></span>
					<!-- </div> -->
					<input id="password" class="form-control" formControlName="password" placeholder="Password"
						type="password" [ngClass]="{ 'is-invalid': password.invalid && formSubmitAttempt }" />
				</div>
			</div>
			<button type="submit" class="btn btn-primary d-none"></button>
		</form>
	</div>
</div>
<mat-dialog-actions fxLayout fxLayoutGap="10px">
	<span fxFlex></span>
	<!-- <button (click)="submit()" class="btn btn-primary" [disabled]="isSubmitting">
		<ng-container *ngIf="isSubmitting">
			<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
			Loading..
		</ng-container>
		<ng-container *ngIf="!isSubmitting">
			Authenticate
		</ng-container>
	</button> -->
	<loading-button (click)="submit()" [isLoading]="isSubmitting" className="btn-primary">
		<i class="fas fa-unlock me-2"></i>
		Authenticate
	</loading-button>
	<button mat-dialog-close class="btn btn-danger">
		<i class="fa fa-times"></i> Cancel
	</button>
</mat-dialog-actions>
